import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

export default class ReportService {
  private schoolUuid: string;

  constructor(schoolUuid: string) {
    this.schoolUuid = schoolUuid;
  }

  private basePath(): string {
    return `/v1/schools/${this.schoolUuid}/reports`;
  }

  async listReports(): Promise<ReportSummary[]> {
    const response = await HttpService.getJson<EdudoResponse<ReportSummary[]>>(
      this.basePath()
    );
    return response.data;
  }

  async getReport(reportId: string): Promise<ReportDetail> {
    const response = await HttpService.getJson<EdudoResponse<ReportDetail>>(
      `${this.basePath()}/${reportId}`
    );
    return response.data;
  }

  async generateReport(reportId: string, filters: Record<string, any>): Promise<ReportGenerateResponse> {
    const response = await HttpService.postJson<EdudoResponse<ReportGenerateResponse>>(
      `${this.basePath()}/${reportId}`,
      { filters }
    );
    return response.data;
  }

  async getResult(reportId: string, resultId: string): Promise<ReportResult> {
    const response = await HttpService.getJson<EdudoResponse<ReportResult>>(
      `${this.basePath()}/${reportId}/results/${resultId}`
    );
    return response.data;
  }
}
